import { render } from "./ChangeProfile.vue?vue&type=template&id=567c63fa"
import script from "./ChangeProfile.vue?vue&type=script&lang=js"
export * from "./ChangeProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__